module.exports = __webpack_public_path__ + "img/modern-pride.49996e3c.png";